export class Building {
    corporationNumber: string;
    corporationNumberName: string;
    timezone: string;
    itemName: string;

    static fromShortBuildingData(item): Building {
        const building = new Building(item.id, item.name, item.suits);
        building.corporationNumber = item.corporationNumber;
        building.corporationNumberName = item.corporationNumberName;
        building.address = item.address;
        building.timezone = item.timeZone ? item.timeZone.value : '';
        building.itemName = building.name;
        return building;
    }

    constructor(
        public id: string = null,
        public name: string = '',
        public address: string = '',
        public suites: Array<number> = [],
        public disabled: boolean = false
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Building.ts